import React, { useState } from "react";
import CheckAttendancePage from "pages/hr/manage/components/check-attendance-page";

const AttendanceCheckPage = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");

  const handleAttendanceSuccess = () => {
    setToastMessage("Attendance recorded successfully!");
    setToastType("success");
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleAttendanceError = (error) => {
    setToastMessage(error.message || "Failed to record attendance");
    setToastType("error");
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  return (
    <>
      {/* Simple Toast Notification */}
      {showToast && (
        <div
          className={`toast align-items-center text-white bg-${toastType === "success" ? "success" : "danger"} border-0 position-fixed`}
          style={{
            top: "20px",
            right: "20px",
            zIndex: 9999,
            minWidth: "300px"
          }}
          role="alert"
        >
          <div className="d-flex">
            <div className="toast-body">
              {toastMessage}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
            ></button>
          </div>
        </div>
      )}

      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="card shadow">
                <div className="card-body p-0">
                  <CheckAttendancePage
                    onSuccess={handleAttendanceSuccess}
                    onError={handleAttendanceError}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceCheckPage;
